import { FC, useContext, useRef, useState } from 'react';

import { Button } from '@smartshell/ui-kit';

import { useUploadFile } from 'hooks';
import { LocalizationContext } from 'localization';
import notification from 'services/notificationService';

import { IScreenshotItemProps } from './interfaces';
import s from './ScreenshotItem.module.scss';
export const ScreenshotItem: FC<IScreenshotItemProps> = ({
  value,
  onDelete,
  onReplace,
}) => {
  const { t } = useContext(LocalizationContext);
  const [isHovered, setIsHovered] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const { uploadImage } = useUploadFile();

  return (
    <div
      className={s.image_container}
      style={{ backgroundImage: `url("${value}")` }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isHovered && (
        <div className={s.image_controls}>
          <Button
            className={s.delete_button}
            onClick={onDelete}
            iconName="BucketIcon"
            onlyIcon
            color="red"
            variant="ghost"
          ></Button>

          <Button
            iconName="EditIcon"
            onlyIcon
            className={s.edit_button}
            onClick={() => inputRef.current?.click()}
            fullWidth
            variant="ghost"
          ></Button>
        </div>
      )}

      <input
        ref={inputRef}
        type="file"
        accept=".png,.jpg,.jpeg"
        hidden
        onChange={async (e) => {
          const file = e.target.files?.[0];
          e.target.value = '';

          if (!file) return;

          try {
            const newUrl = await uploadImage(file);
            onReplace(newUrl);
          } catch (error) {
            notification.info({
              t,
              type: 'error',
              title: t('upload.file.error'),
              message: String(error),
            });
          }
        }}
      />
    </div>
  );
};
